import React, { useState } from "react";
import "./Testimonials.css";
import { Avatar } from "@material-ui/core";

const Testimonials = () => {
  const [step, setStep] = useState(0);
  let timer = setInterval(slide, 5000);

  function slide() {
    if (step < 2) {
      setStep(step + 1);
    }
    if (step >= 2) {
      setStep(0);
    }

    clearInterval(timer);
  }

  const quotes = {
    0: {
      name: "Keanan Wilson",
      designation: "Co-Founder",
      noImg: "KW",
      profilePic: "",
      quote:
        "It was a great project done by Enviary team and we are really very happy with the eCommerce email automation strategy outcome. Each and every aspect of our digital channels was used in the analysis phase that makes the email marketing work wonders for us. We could have not done it alone so Enviary worked as an extended arm of our email marketing team to help retain our customers and increase ROI and LTV from our existing customer-base. Well done.",
      company: "Eagle Rocket LLC",
    },
    1: {
      name: "Aaron Wilt",
      designation: "Founder",
      noImg: "AW",
      profilePic: `${require("../Img/testimonials/Aaron.png")}`,
      quote:
        "I have worked with Enviary for a while now. Their knowledgeable team has helped me understand the difference between email marketing and right communication with the right prospect at the right time. On a side note they taught me how to do behavioural marketing in a passive manner and I use that term as in conversation as much as I can. Great communication, excellent work ethics and very reliable teams.",
    },
    2: {
      name: "Matt Close",
      designation: "Founder",
      noImg: "MC",
      profilePic: `${require("../Img/testimonials/Matt.jpeg")}`,
      quote:
        "Enviary has been working with me for a couple of years now. We’ve done projects of migrating from Mailchimp to Klaviyo, eCommerce email automation strategy and automated flows. They always remain ahead of the curve. The team is very competent. They always seem to have most up to date strategic and tactical plan of action. It's great to have a safe pair of hands with so much expertise on your side.",
      company: "Nextlevelbc",
    },
  };

  return (
    <div className="testimonials" id="testimonial">
      <div className="testimonials__title">
        <h2>client's testimonials</h2>
        <p>see what our top valuable clients say about us</p>
        <hr />
      </div>
      <div className="testimonials__content">
        {/* <div className="testimonials__forward">
          <ArrowBackIosIcon />
        </div> */}
        <div className="testimonials__content__sec">
          <Avatar className="pic" src={quotes[step].profilePic}>
            {quotes[step].noImg}
          </Avatar>
          <p>{quotes[step].quote}</p>

          <div className="testimonials__client">
            <div className="client__personal">
              <h4>{quotes[step].name}</h4>
              <p>{quotes[step].designation}</p>
            </div>
            <h5>{quotes[step].company}</h5>
          </div>
        </div>
        {/* <div className="testimonials__backward">
          <ArrowForwardIosIcon onClick={slide} />
        </div> */}
      </div>
    </div>
  );
};

export default Testimonials;
